import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // check for consent
  console.log("check user consent in routing", user.consent)

  if (!user.consent && location.pathname !== "/consent") {
    return <Navigate to="/consent"/>;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
